import * as cfe from 'ego-cfe';
import * as api from 'ego-sdk-js';
import React from 'react';

import SectionHeaderTab from './SectionHeaderTab';
import Thread, { ThreadMethods, ThreadProps } from './Thread';

const FeedEntryFfaThread = (
  props: Omit<
    ThreadProps,
    | 'threadId'
    | 'headerOpts'
    | 'rootCommentOps'
    | 'size'
    | 'authorUserId'
    | 'showQuickCommentInput'
    | 'watermark'
    | 'seenWatermark'
  > & {
    feed: api.feed.IFeedInfo;
    entry: api.feed.IFeedEntryReference;
    hideSectionHeaderTab?: boolean;
  },
) => {
  if (props.entry['.tag'] !== 'share') {
    throw Error('Unexpected entry type');
  }
  const { entry, ...rest } = props;
  const rootCommentOpts = React.useMemo(
    () => ({
      maxLength: 240,
    }),
    [],
  );
  const size = React.useMemo(
    () => ({
      depth: 8,
      initDepth: 8,
      initRepliesPerLevel: 10,
      repliesPerLevel: 10,
    }),
    [],
  );
  const threadRef = React.useRef<ThreadMethods | null>(null);
  const [threadCollapsed, setThreadCollapsed] = React.useState(false);

  const title = props.accountInfo
    ? 'Conversation with ' + cfe.ApiHelpers.getShareFeedName(props.feed, props.accountInfo.user_id)
    : null;
  return (
    <div>
      {title && !props.hideSectionHeaderTab ? (
        <>
          <SectionHeaderTab
            className="!tw-mb-4"
            title={title}
            titleClassName={threadCollapsed ? 'tw-italic' : undefined}
            round="right"
            onClick={() => {
              setThreadCollapsed(!threadCollapsed);
              if (threadRef.current) {
                threadRef.current.collapse(!threadCollapsed);
              }
            }}
          />
          <div className="tw-mb-2" />
        </>
      ) : null}
      <div className={!props.hideSectionHeaderTab ? 'kb-pad-4-na' : undefined}>
        <Thread
          {...rest}
          key={props.entry.ffa_thread_id}
          threadId={props.entry.ffa_thread_id}
          viaEntryId={props.entry.entry_id}
          showQuickCommentInput
          size={size}
          rootCommentOpts={rootCommentOpts}
          authorUserId={props.entry.added_by?.user_id}
          watermark={props.entry.for_viewer.seen?.watermark ?? 0}
          seenWatermark={props.entry.for_viewer.seen?.seen_watermark ?? 0}
        />
      </div>
    </div>
  );
};

export default FeedEntryFfaThread;
